import { useState, useEffect } from "react";
import { getCrmSektorler, addCrmSektor, deleteCrmSektor } from "../services/api";

const card = { background: "var(--bg-card-alt)", border: "1px solid var(--accent-bg)", borderRadius: 10, padding: 20 };
const inp  = { background: "var(--bg-card)", border: "1px solid var(--border)", borderRadius: 7, padding: "8px 11px", color: "var(--text-primary)", fontSize: 13, outline: "none", boxSizing: "border-box" };
const btn  = (bg, color) => ({ background: bg, color, border: "none", borderRadius: 7, padding: "9px 18px", fontSize: 13, fontWeight: 600, cursor: "pointer" });

export default function CrmSektorTanimlari() {
  const [sektorler, setSektorler] = useState([]);
  const [loading, setLoading] = useState(false);
  const [ad, setAd] = useState("");
  const [msg, setMsg] = useState(null);

  useEffect(() => { load(); }, []);

  async function load() {
    setLoading(true);
    try { setSektorler((await getCrmSektorler()).data); }
    catch { flash("Yuklenemedi", "error"); }
    finally { setLoading(false); }
  }

  function flash(text, type = "success") {
    setMsg({ text, type });
    setTimeout(() => setMsg(null), 4000);
  }

  async function handleSubmit(e) {
    e.preventDefault();
    if (!ad.trim()) return;
    try {
      await addCrmSektor(ad.trim());
      flash("Sektor eklendi");
      setAd("");
      load();
    } catch (err) {
      flash(err.response?.data?.detail || "Hata (belki zaten var)", "error");
    }
  }

  async function handleDelete(id, adi) {
    if (!window.confirm(`"${adi}" sektoru silinsin mi?`)) return;
    try {
      await deleteCrmSektor(id);
      flash("Silindi");
      load();
    } catch { flash("Silinemedi", "error"); }
  }

  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 20, maxWidth: 480 }}>
      {msg && (
        <div style={{
          padding: "11px 16px", borderRadius: 8, fontSize: 13, fontWeight: 500,
          background: msg.type === "error" ? "#3f1515" : "#0f3d20",
          border: `1px solid ${msg.type === "error" ? "#dc2626" : "#16a34a"}`,
          color: msg.type === "error" ? "#fca5a5" : "#86efac",
        }}>{msg.text}</div>
      )}

      <div style={card}>
        <div style={{ fontSize: 14, fontWeight: 600, color: "var(--accent-text)", marginBottom: 4 }}>Sektor Tanimlari</div>
        <div style={{ fontSize: 11, color: "var(--text-faint)", marginBottom: 16 }}>
          Firma formundaki "Sektor" alani buradaki listeden secilir.
        </div>
        <form onSubmit={handleSubmit} style={{ display: "flex", gap: 10 }}>
          <input
            style={{ ...inp, flex: 1 }}
            placeholder="Yeni sektor adi..."
            maxLength={100}
            value={ad}
            onChange={(e) => setAd(e.target.value)}
          />
          <button type="submit" style={btn("var(--accent)", "#fff")}>Ekle</button>
        </form>
      </div>

      <div style={{ ...card, padding: 0, overflow: "hidden" }}>
        {loading && <div style={{ padding: 24, textAlign: "center", color: "var(--text-faint)", fontSize: 13 }}>Yukleniyor...</div>}
        {!loading && sektorler.length === 0 && (
          <div style={{ padding: 24, textAlign: "center", color: "var(--text-faint)", fontSize: 13 }}>Henuz sektor tanimlanmamis.</div>
        )}
        {sektorler.map((s) => (
          <div key={s.ID} style={{
            display: "flex", alignItems: "center", justifyContent: "space-between",
            padding: "10px 16px", borderBottom: "1px solid var(--border-hairline)", fontSize: 13,
          }}>
            <span style={{ color: "var(--text-primary)" }}>{s.Ad}</span>
            <button onClick={() => handleDelete(s.ID, s.Ad)}
              style={{ background: "#3f1515", color: "#fca5a5", border: "1px solid #7f1d1d", borderRadius: 6, padding: "4px 10px", fontSize: 11, cursor: "pointer" }}>
              Sil
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}
